import { makeImmutable } from "../../core";
import { Availability } from "../Availability";
/**
 * Information that the orrder should be fulfilled on a specified hour.
 */
export class OnTimeFulfillmentTime {
    constructor(params) {
        var _a;
        this.type = "OnTime";
        this.date = params.date;
        this._label = (_a = params.label) !== null && _a !== void 0 ? _a : null;
        makeImmutable(this);
    }
    get label() {
        return this._label !== null ? this._label : "";
    }
    get availability() {
        return Availability.boolean({
            InvalidDate: !this.date.isValid,
        });
    }
    /**
     * @returns data to be sent to the backend
     */
    get checkoutData() {
        return this.date.toString;
    }
}
